export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!!from?.meta?.layout && !to?.meta?.layout) {
    // Restoring header for default layout when exiting layout specific pages
    // and returning to default layout, in case the header was not visibile
    // when leaving the layout
    useState("scrolling-up").value = true
  }
})
